import axios from 'axios'; //only for uploads as of December 31st, 2021
import React, { Fragment, useState, useEffect, useRef } from 'react';

import Uppy from '@uppy/core';
import Tus from '@uppy/tus';

import {
    Link,
    // withRouter,
    useLocation,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { hostReviewsEvent } from '../../actions/host';
import { NOTIFICATION_DIALOG_DELAY_MS } from '../../utils/notificationDeepLink';
import porchlightLogo from '../../img/Porchlight_logo05-17.svg';

import {
    TextField,
    //Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputAdornment,
    Grid,
    Box,
    Typography,
    Rating,
    Dialog,
    DialogContent,
    MobileStepper,
} from '@mui/material';
import Masonry from '@mui/lab/Masonry';
// import { PhoneInput as ReactPhoneInput } from 'react-phone-input-2';
import { styled } from '@mui/material/styles';
import Button from '../layout/SvgButton';

import MenuBookTwoToneIcon from '@mui/icons-material/MenuBookTwoTone';

import { SpinnerCircular } from 'spinners-react';

import HostProfile from '../hosts/HostProfile';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import FlareTwoToneIcon from '@mui/icons-material/FlareTwoTone';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useTransition, animated, config } from '@react-spring/web';
import '../../formCards.css';

import { toTitleCase, StackDateforDisplay } from '../../actions/app';
import FileUploader from '../../common/components/FileUploader';
import VerifyAttendeesList from '../attendees/VerifyAttendeesList';
import { getVerifyAttendeesCopy } from '../attendees/VerifyAttendeesDialog';

// import { HOST_UPLOADED_FILES } from '../../actions/types';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

//filter() for Objects -- https://stackoverflow.com/a/37616104/3338608
Object.filter = (obj, predicate) =>
    Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), []);

const UploadInput = styled('input')({
    display: 'none',
});

const HostReviewsEvent = ({
    hostMe,
    history,
    auth,
    theEvent,
    hostReviewsEvent,
    onNotificationDialogClose,
    // thisHostEvent,
}) => {
    // const dispatch = useDispatch();
    //File Uploading with Uppy
    // if (localStorage.token) {
    let numRequests = 0;
    const uppy = new Uppy({
        id: 'uppity',
        // autoProceed: true,
        autoProceed: false,
        // debug: true,
        formData: true,
        theme: 'dark',
        allowedFileTypes: ['image/*', 'video/*'],

        meta: {
            // bookingWhen: thisEvent.bookingWhen.slice(0, 10),
            // artist: thisEvent.confirmedArtist || thisEvent.artist,
            // host: thisEvent.confirmedHost,
            thisEvent: theEvent._id,
            // driveFolderID: thisEvent.driveFolderID,
            // location:
            //     thisEvent.bookingWhere.city +
            //     ', ' +
            //     thisEvent.bookingWhere.state,
        },
    }).use(Tus, {
        endpoint: 'https://app.porchlight.art/api/uploads/file', //needs to be called over https
        // endpoint: '/api/uploads/file',
        headers: {
            'x-auth-token': localStorage.token,
        },
        onBeforeRequest: async (req, file) => {
            // make sure it has a Google Drive Folder to go into
            // console.log('onBeforeRequest req', req);
            // console.log('onBeforeRequest file', file);
            if (numRequests === 0) {
                //only make the folder once (we don't need a bunch of empty folders in the Drive)
                try {
                    numRequests++;
                    const config = {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    };
                    const res = await axios.post(
                        '/api/uploads/createDriveFolder',
                        { thisEvent: file.meta.thisEvent },
                        config
                    );
                    // console.log(
                    //     `/api/uploads/createDriveFolder res index(${numRequests})`,
                    //     res
                    // );
                } catch (err) {
                    console.log('error: ' + err);
                    // const errors = err.response.data.errors;
                    // if (errors) {
                    //     errors.forEach((error) =>
                    //         dispatch(setAlert(error.msg, 'danger'))
                    //     );
                    // }
                    // dispatch({
                    //     type: UPDATE_EVENT_ERROR,
                    //     payload: {
                    //         msg: err.response.statusText,
                    //         status: err.response.status,
                    //     },
                    // });
                    // dispatch(setAlert('Update Error: ' + err, 'danger')); // alertType = 'success' to add a class of alert-success to the alert (alert.alertType used in /components/layout/Alert.js)
                }
            }
        },
    });

    async function checkForUpdates(theEventId, delay = 2000) {
        try {
            // if (delay < 1000 * 100) {
            const updatedEvent = await axios.get(
                `/api/uploads/eventUploadedFiles/${theEventId}`
            );
            console.log('updatedEvent.data', updatedEvent.data);

            setTheUploadedFiles(updatedEvent.data.uploadedFiles);

            // Check if all images have driveIDs
            const imagesWithoutDriveID = updatedEvent.data.uploadedFiles.filter(
                (uploadedImage) => !uploadedImage.driveID
            );

            if (imagesWithoutDriveID.length === 0) {
                console.log('All images have driveIDs now.');
                // dispatch({
                //     type: HOST_UPLOADED_FILES,
                //     payload: updatedEvent.data,
                // });
                return; // Exit the recursion if all images have driveIDs
            }

            // If not, wait for the specified delay and check again
            setTimeout(async () => {
                await checkForUpdates(theEventId, delay + 2000); //add a second to the delay every time we run it — just trying to save on resources
            }, delay);
            // } else {
            //     console.log(
            //         'The images don’t all have driveIDs, but we can’t be waiting FOREVER!'
            //     );
            //     return;
            // }
        } catch (error) {
            console.error(error);
            return;
            // You might want to retry or exit the loop based on the error type
        }
    }

    uppy.on('upload-success', async (file, response) => {
        console.log('Rusty upload-success file, response', file, response);
        // const config = {
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        // };

        console.log('Rusty upload-success theEvent._id', theEvent._id);
        console.log(
            'Rusty upload-success file.meta.thisEvent',
            file.meta.thisEvent
        );
        try {
            // let updatedEvent = await axios.get(
            //     '/api/uploads/eventUploadedFiles/' + theEvent._id
            //     // { thisEvent: file.meta.thisEvent },
            //     // { thisEvent: theEvent._id },
            //     // config
            // );

            // console.log('updatedEvent', updatedEvent);
            // console.log(
            //     'updatedEvent.data.uploadedFiles.filter((uploadedImage) => !uploadedImage.driveID)',
            //     updatedEvent.data.uploadedFiles.filter(
            //         (uploadedImage) => !uploadedImage.driveID
            //     )
            // );
            checkForUpdates(theEvent._id);

            // do {
            //     setTimeout(async () => {
            //         updatedEvent = await axios.get(
            //             '/api/uploads/eventUploadedFiles',
            //             { thisEvent: theEvent._id },
            //             config
            //         );

            //         console.log('do updatedEvent', updatedEvent);
            //     }, 3000);
            // } while (
            //     updatedEvent &&
            //     updatedEvent.data &&
            //     updatedEvent.data.uploadedFiles &&
            //     updatedEvent.data.uploadedFiles.length > 0 &&
            //     updatedEvent.data.uploadedFiles.filter(
            //         (uploadedImage) => !uploadedImage.driveID
            //     ).length > 0
            // );
        } catch (error) {
            console.error(error);
        }

        // start watching theEvent.uploadedFiles on a setInterval, for the driveID to be updated
    });
    // }

    const loading = false; //a bunch of things are dependent on it; I should really just take it out.
    // const dispatch = useDispatch();

    const [theReview, setTheReview] = useState({});
    const [theOffer, setTheOffer] = useState({});
    const [theHost, setTheHost] = useState({});
    const [theArtist, setTheArtist] = useState({});
    const [theUploadedFiles, setTheUploadedFiles] = useState([]);

    // console.log('HostReviewsEvent theEvent', theEvent);

    useEffect(() => {
        if (
            theEvent &&
            theEvent.uploadedFiles &&
            theEvent.uploadedFiles.length > 0
        ) {
            // console.log(
            //     'change in theEvent.uploadedFiles',
            //     theEvent.uploadedFiles
            // );
            setTheUploadedFiles(theEvent.uploadedFiles);
        }
    }, [theEvent.uploadedFiles]);

    // useEffect(() => {
    //     if (
    //         thisHostEvent &&
    //         thisHostEvent.uploadedFiles &&
    //         thisHostEvent.uploadedFiles.length > 0
    //     ) {
    //         console.log(
    //             'change in thisHostEvent.uploadedFiles',
    //             thisHostEvent.uploadedFiles
    //         );
    //         setTheUploadedFiles(thisHostEvent.uploadedFiles);
    //     }
    // }, [thisHostEvent.uploadedFiles]);

    useEffect(() => {
        if (
            theEvent &&
            theEvent._id &&
            theEvent.offersFromHosts &&
            theEvent.offersFromHosts.length > 0 &&
            theEvent.offersFromHosts.filter((thisOffer) => {
                // console.log('thisOffer.status', thisOffer.status);
                if (thisOffer.status === 'ACCEPTED') {
                    return thisOffer;
                }
                // else return thisOffer;
                else return false;
            }).length > 0
        ) {
            const theAcceptedOffer = theEvent.offersFromHosts.filter(
                (thisOffer) => {
                    console.log('thisOffer.status', thisOffer.status);
                    if (thisOffer.status === 'ACCEPTED') {
                        return thisOffer;
                    }
                    // else return thisOffer;
                    else return false;
                }
            )[0];
            // console.log('theAcceptedOffer', theAcceptedOffer);
            setTheOffer(theAcceptedOffer);
        }
        if (theEvent.hostReviewOfEvent) {
            setTheReview(theEvent.hostReviewOfEvent);
        }
        if (theEvent.artist) {
            setTheArtist(theEvent.artist);
        } else if (
            theEvent.confirmedArtist &&
            theEvent.preferredArtists &&
            theEvent.preferredArtists.length > 0
        ) {
            theEvent.preferredArtists.map((prefArtist) => {
                if (prefArtist._id === theEvent.confirmedArtist) {
                    setTheArtist(prefArtist);
                }
            });
        }
    }, [theEvent]);
    useEffect(() => {
        if (theEvent.hostReviewOfEvent) {
            setTheReview(theEvent.hostReviewOfEvent);
        }
    }, [theEvent?.hostReviewOfEvent]);

    useEffect(() => {
        if (theOffer && theOffer.host) {
            setTheHost(theOffer.host);

            // console.log('the ACCEPTED Offer theOffer.host', theOffer.host);
        }
        if (hostMe) {
            setTheHost(hostMe);
        }
        // console.log('the ACCEPTED Offer', theOffer);
        // console.log('the ACCEPTED Offer Host', theHost);
    }, [theOffer, hostMe]);

    const [formData, setFormData] = useState({
        eventId: '',
        artistId: '',
        hostId: '',
        bookingWhen: '',
        bookingWhere: {},

        //hostReviewsEvent
        processOfConnecting: 0,
        curationSuggestions: '',
        howMuchAttentionToGuide: '',
        howHelpfulWasGuide: 0,
        guideSuggestions: '',
        eventbriteExperience: 0,
        eventbriteSuggestions: '',
        porchlightCommunications: 0,
        artistCommunications: 0,
        attendanceExpectations: '',
        promotionInsight: '',
        experienceMeetingArtist: '',
        audienceInteraction: '',
        artistVibe: 0,
        artistMusicalSkill: 0,
        artistVocalSkill: 0,
        artistSongwritingSkill: 0,
        overnightExperience: 0,
        critiqueOfArtist: '',
        critiqueOfPorchlight: '',
        experienceWithPorchlight: '',
        mediaContent: [], //list of URLs — maybe Google Drive links
        testimonial: '',
        willingToShareMore: '',
        obstacleOvercome: '',
        artistRating: 0,
        artistFeedback: '',
        otherArtistFeedback: '',
        otherArtistFeedbackPrivacy: '',
        porchlightRating: 0,
        porchlightFeedback: '',
        porchlightTestimonial: '',
        recommendations: '',
    });

    useEffect(() => {
        if (theEvent._id && theReview) {
            setFormData({
                eventId: loading || !theEvent._id ? '' : theEvent._id,
                artistId:
                    loading ||
                    (!theArtist?._id && !theEvent?.confirmedArtist?._id)
                        ? ''
                        : theArtist?._id || theEvent?.confirmedArtist?._id,
                hostId: loading || !theHost._id ? '' : theHost._id,
                // hostId:
                //     loading ||
                //     !theOffer.host ||
                //     (theOffer.host && !theOffer.host._id)
                //         ? ''
                //         : theOffer.host._id,
                bookingWhen:
                    loading || !theEvent.bookingWhen
                        ? ''
                        : theEvent.bookingWhen,
                bookingWhere:
                    loading || !theEvent.bookingWhere
                        ? {}
                        : theEvent.bookingWhere,

                processOfConnecting:
                    loading || !theReview.processOfConnecting
                        ? 0
                        : theReview.processOfConnecting,
                curationSuggestions:
                    loading || !theReview.curationSuggestions
                        ? ''
                        : theReview.curationSuggestions,
                howMuchAttentionToGuide:
                    loading || !theReview.howMuchAttentionToGuide
                        ? ''
                        : theReview.howMuchAttentionToGuide,
                howHelpfulWasGuide:
                    loading || !theReview.howHelpfulWasGuide
                        ? 0
                        : theReview.howHelpfulWasGuide,
                guideSuggestions:
                    loading || !theReview.guideSuggestions
                        ? ''
                        : theReview.guideSuggestions,
                eventbriteExperience:
                    loading || !theReview.eventbriteExperience
                        ? 0
                        : theReview.eventbriteExperience,
                eventbriteSuggestions:
                    loading || !theReview.eventbriteSuggestions
                        ? ''
                        : theReview.eventbriteSuggestions,
                porchlightCommunications:
                    loading || !theReview.porchlightCommunications
                        ? 0
                        : theReview.porchlightCommunications,
                artistCommunications:
                    loading || !theReview.artistCommunications
                        ? 0
                        : theReview.artistCommunications,
                attendanceExpectations:
                    loading || !theReview.attendanceExpectations
                        ? ''
                        : theReview.attendanceExpectations,
                promotionInsight:
                    loading || !theReview.promotionInsight
                        ? ''
                        : theReview.promotionInsight,
                experienceMeetingArtist:
                    loading || !theReview.experienceMeetingArtist
                        ? ''
                        : theReview.experienceMeetingArtist,
                audienceInteraction:
                    loading || !theReview.audienceInteraction
                        ? ''
                        : theReview.audienceInteraction,
                artistVibe:
                    loading || !theReview.artistVibe ? 0 : theReview.artistVibe,
                artistMusicalSkill:
                    loading || !theReview.artistMusicalSkill
                        ? 0
                        : theReview.artistMusicalSkill,
                artistVocalSkill:
                    loading || !theReview.artistVocalSkill
                        ? 0
                        : theReview.artistVocalSkill,
                artistSongwritingSkill:
                    loading || !theReview.artistSongwritingSkill
                        ? 0
                        : theReview.artistSongwritingSkill,
                overnightExperience:
                    loading || !theReview.overnightExperience
                        ? 0
                        : theReview.overnightExperience,
                critiqueOfArtist:
                    loading || !theReview.critiqueOfArtist
                        ? ''
                        : theReview.critiqueOfArtist,
                critiqueOfPorchlight:
                    loading || !theReview.critiqueOfPorchlight
                        ? ''
                        : theReview.critiqueOfPorchlight,
                experienceWithPorchlight:
                    loading || !theReview.experienceWithPorchlight
                        ? ''
                        : theReview.experienceWithPorchlight,
                mediaContent:
                    loading || !theReview.mediaContent
                        ? []
                        : theReview.mediaContent,
                testimonial:
                    loading || !theReview.testimonial
                        ? ''
                        : theReview.testimonial,
                willingToShareMore:
                    loading || !theReview.willingToShareMore
                        ? ''
                        : theReview.willingToShareMore,
                obstacleOvercome:
                    loading || !theReview.obstacleOvercome
                        ? ''
                        : theReview.obstacleOvercome,
                artistRating:
                    loading || !theReview.artistRating
                        ? 0
                        : theReview.artistRating,
                artistFeedback:
                    loading || !theReview.artistFeedback
                        ? ''
                        : theReview.artistFeedback,
                otherArtistFeedback:
                    loading || !theReview.otherArtistFeedback
                        ? ''
                        : theReview.otherArtistFeedback,
                otherArtistFeedbackPrivacy:
                    loading || !theReview.otherArtistFeedbackPrivacy
                        ? ''
                        : theReview.otherArtistFeedbackPrivacy,
                porchlightRating:
                    loading || !theReview.porchlightRating
                        ? 0
                        : theReview.porchlightRating,
                porchlightFeedback:
                    loading || !theReview.porchlightFeedback
                        ? ''
                        : theReview.porchlightFeedback,
                porchlightTestimonial:
                    loading || !theReview.porchlightTestimonial
                        ? ''
                        : theReview.porchlightTestimonial,
                recommendations:
                    loading || !theReview.recommendations
                        ? ''
                        : theReview.recommendations,
            });
        } else if (theEvent._id) {
            setFormData({
                eventId: loading || !theEvent._id ? '' : theEvent._id,
                artistId:
                    loading ||
                    (!theArtist?._id && !theEvent?.confirmedArtist?._id)
                        ? ''
                        : theArtist?._id || theEvent?.confirmedArtist?._id,
                hostId:
                    loading || (!hostMe._id && !theHost._id)
                        ? ''
                        : hostMe._id || theHost._id,
                // hostId:
                //     loading ||
                //     !theOffer.host ||
                //     (theOffer.host && !theOffer.host._id)
                //         ? ''
                //         : theOffer.host._id,
                bookingWhen:
                    loading || !theEvent.bookingWhen
                        ? ''
                        : theEvent.bookingWhen,
                bookingWhere:
                    loading || !theEvent.bookingWhere
                        ? {}
                        : theEvent.bookingWhere,
            });
        }
    }, [
        auth.loading,
        theArtist,
        theEvent,
        theOffer,
        theReview,
        theHost,
        hostMe,
    ]);

    const {
        processOfConnecting,
        curationSuggestions,
        howMuchAttentionToGuide,
        howHelpfulWasGuide,
        guideSuggestions,
        eventbriteExperience,
        eventbriteSuggestions,
        porchlightCommunications,
        artistCommunications,
        attendanceExpectations,
        promotionInsight,
        experienceMeetingArtist,
        audienceInteraction,
        artistVibe,
        artistMusicalSkill,
        artistVocalSkill,
        artistSongwritingSkill,
        overnightExperience,
        critiqueOfArtist,
        critiqueOfPorchlight,
        experienceWithPorchlight,
        mediaContent, //list of URLs — maybe Google Drive links
        testimonial,
        willingToShareMore,
        obstacleOvercome,
        artistRating,
        artistFeedback,
        otherArtistFeedback,
        otherArtistFeedbackPrivacy,
        porchlightRating,
        porchlightFeedback,
        porchlightTestimonial,
        recommendations,
    } = formData;

    const onChange = (e) => {
        //console.log(e);
        //console.log(Object.keys(formGroups).length);
        changesMade.current = true;
        let targetValue = e.target.value;
        switch (e.target.type) {
            case 'checkbox':
                targetValue = e.target.checked;
                break;
            default:
                targetValue = e.target.value;
        }
        const targetName = e.target.name.split('.');
        //console.log(targetName + ': ' + targetValue);
        //setFormData({ ...formData, [e.target.name]: targetValue });
        if (targetName.length === 1) {
            setFormData({ ...formData, [targetName[0]]: targetValue });
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [targetName[0]]: {
                    ...prevData[targetName[0]],
                    [targetName[1]]: targetValue,
                },
            }));
            //console.log(formData);
        }
    };

    //const [changesMade, setChangesMade] = useState(false);
    const changesMade = useRef(false);
    const firstLoad = useRef(true);

    const onSubmit = (e) => {
        e.preventDefault();
        //console.log('Submitting...');
        hostReviewsEvent(formData, history, true);
        changesMade.current = false;
    };

    const verifyAttendeesCopy = getVerifyAttendeesCopy(theEvent?.bookingWhen);

    const formGroups = {
        // titleCard: [
        //     [
        //         <FormLabel component="legend">
        //             Thank you for taking a moment to review the Porchlight
        //             booking and show advancement process.
        //         </FormLabel>,
        //         <FormLabel
        //             component="small"
        //             sx={{ textAlign: 'center', display: 'block' }}
        //         >
        //             Let's get started!
        //         </FormLabel>,
        //     ],
        // ],

        whoShowedUp: [
            [
                <FormLabel component="legend">
                    {verifyAttendeesCopy.title}
                </FormLabel>,
                <FormLabel
                    component="small"
                    sx={{
                        textAlign: 'center',
                        display: 'block',
                    }}
                >
                    {verifyAttendeesCopy.subtitle}
                </FormLabel>,
            ],
            [
                <Box sx={{ width: '100%', marginTop: '8px' }}>
                    <VerifyAttendeesList
                        eventId={theEvent._id}
                        theEvent={theEvent}
                        attendeeSummaries={theEvent.attendeeSummaries}
                        canVerify={verifyAttendeesCopy.canVerify}
                    />
                </Box>,
            ],
        ],

        artistRating: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theArtist?.squareImg || theEvent?.confirmedArtist?.squareImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    How was your overall experience hosting{' '}
                    {theArtist?.stageName ||
                        theEvent?.confirmedArtist?.stageName}{' '}
                    on{' '}
                    {new Date(theEvent?.bookingWhen).toLocaleDateString(
                        undefined,
                        {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                        }
                    )}
                    ?
                </FormLabel>,
                <FormLabel
                    component="small"
                    sx={{ textAlign: 'center', display: 'block' }}
                >
                    1 star being worst, 5 stars being best.
                </FormLabel>,
            ],
            [
                <FormControl component="fieldset">
                    <Rating
                        size="large"
                        id="artistRating"
                        value={artistRating}
                        name="artistRating"
                        onChange={(e) => onChange(e)}
                    />
                </FormControl>,
            ],
        ],
        artistFeedback: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theArtist?.squareImg || theEvent?.confirmedArtist?.squareImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    FOR INTERNAL USE ONLY: Tell us a bit more about hosting{' '}
                    {theArtist?.stageName ||
                        theEvent?.confirmedArtist?.stageName}
                    {', '}
                    including both highlights and challenges.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="artistFeedback"
                        id="artistFeedback"
                        placeholder={'Type your response here'}
                        value={artistFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        testimonial: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theArtist?.squareImg || theEvent?.confirmedArtist?.squareImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel
                    component="legend"
                    sx={{ paddingTop: '10px', textWrap: 'balance' }}
                >
                    TESTIMONIAL: What would you like others to know about{' '}
                    {theArtist?.stageName ||
                        theEvent?.confirmedArtist?.stageName}
                    , their work, or this particular gathering?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="testimonial"
                        id="testimonial"
                        placeholder={'Type your response here'}
                        value={testimonial}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        critiqueOfArtist: [
            [
                <Box
                    className="squareImgInACircle"
                    sx={{
                        height: '150px',
                        width: '150px',
                        maxHeight: '150px',
                        maxWidth: '150px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        backgroundImage: `url("${theArtist?.squareImg || theEvent?.confirmedArtist?.squareImg}")`,
                        backgroundPosition: '50% 25%',
                        backgroundSize: 'cover',
                        padding: '4px',
                        backgroundClip: 'content-box',
                        //border: '1px solid var(--primary-color)',
                        border: '1px solid var(--primary-color)',

                        margin: '0 auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'end',
                        aspectRatio: '1 / 1',
                    }}
                ></Box>,
                <FormLabel component="legend">
                    FOR ARTIST: Artists often ask us for constructive feedback
                    on their performances. Do you have any you'd like us to
                    share with{' '}
                    {theArtist?.stageName ||
                        theEvent?.confirmedArtist?.stageName}
                    ?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="critiqueOfArtist"
                        id="critiqueOfArtist"
                        placeholder={'Type your response here'}
                        value={critiqueOfArtist}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        otherArtistFeedback: [
            [
                <FormLabel component="legend">
                    If there was another artist part of this event, please list
                    their name here and any feedback you'd like to share.
                </FormLabel>,
                <FormLabel component="small">
                    Please indicate whether this feedback is intended for
                    internal review or external testimonial.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="otherArtistFeedback"
                        id="otherArtistFeedback"
                        placeholder={'Type your response here'}
                        value={otherArtistFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],
        porchlightRating: [
            [
                <Box
                    // className="squareImgInACircle"
                    sx={{
                        width: '220px',
                        maxWidth: '220px',
                        backgroundSize: 'cover',
                        backgroundClip: 'content-box',
                        margin: '-20px auto -20px',
                    }}
                >
                    {' '}
                    <img
                        src={porchlightLogo}
                        alt=""
                        className="porchlightLogo"
                    />
                </Box>,
                <FormLabel component="legend" sx={{ marginTop: '0px' }}>
                    How was your overall experience with Porchlight?
                </FormLabel>,
            ],
            [
                <FormControl component="fieldset">
                    <Rating
                        size="large"
                        id="porchlightRating"
                        value={porchlightRating}
                        name="porchlightRating"
                        onChange={(e) => onChange(e)}
                    />
                </FormControl>,
            ],
        ],
        porchlightFeedback: [
            [
                <Box
                    // className="squareImgInACircle"
                    sx={{
                        width: '220px',
                        maxWidth: '220px',
                        backgroundSize: 'cover',
                        backgroundClip: 'content-box',
                        margin: '-20px auto -20px',
                    }}
                >
                    {' '}
                    <img
                        src={porchlightLogo}
                        alt=""
                        className="porchlightLogo"
                    />
                </Box>,
                <FormLabel component="legend">
                    FOR INTERNAL USE ONLY: Tell us a bit more about your
                    experience with Porchlight, including both highlights and
                    challenges.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="porchlightFeedback"
                        id="porchlightFeedback"
                        placeholder={'Type your response here'}
                        value={porchlightFeedback}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        porchlightTestimonial: [
            [
                <Box
                    // className="squareImgInACircle"
                    sx={{
                        width: '220px',
                        maxWidth: '220px',
                        backgroundSize: 'cover',
                        backgroundClip: 'content-box',
                        margin: '-20px auto -20px',
                    }}
                >
                    {' '}
                    <img
                        src={porchlightLogo}
                        alt=""
                        className="porchlightLogo"
                    />
                </Box>,
                <FormLabel component="legend">
                    TESTIMONIAL: What would you like others to know about this
                    network?
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="porchlightTestimonial"
                        id="porchlightTestimonial"
                        placeholder={'Type your response here'}
                        value={porchlightTestimonial}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        obstacleOvercome: [
            [
                <FormLabel
                    component="legend"
                    sx={{ paddingTop: '10px', textWrap: 'balance' }}
                >
                    Practicing hospitality often requires creative problem
                    solving. What is an obstacle you experienced and how did you
                    overcome it?
                </FormLabel>,

                // <FormLabel
                //     component="small"
                //     sx={{ textAlign: 'center', display: 'block' }}
                // >
                //     (If you have a longer story to share about this or something
                //     else,{' '}
                //     <a
                //         href="https://docs.google.com/forms/d/e/1FAIpQLSfe5beCHG88c2PRepmKui2ieHhigT074QTkKwJgEPmMP5gUwg/viewform"
                //         target="_blank"
                //         rel="noopener noreferrer"
                //     >
                //         check out our form here
                //     </a>
                //     .)
                // </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="obstacleOvercome"
                        id="obstacleOvercome"
                        placeholder={'Type your response here'}
                        value={obstacleOvercome}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        recommendations: [
            [
                <FormLabel component="legend">
                    Please share one tool, resource, or tip you'd recommend to
                    others when it comes to hosting.
                </FormLabel>,
            ],
            [
                <Grid
                    item
                    // xs={12}
                    size={{ xs: 12 }}
                    sx={{ margin: '16px auto', width: '70%' }}
                    className="artistNotes_textarea"
                    justifyContent={'center'}
                >
                    <TextField
                        multiline
                        variant="standard"
                        name="recommendations"
                        id="recommendations"
                        placeholder={'Type your response here'}
                        value={recommendations}
                        onChange={(e) => onChange(e)}
                        sx={{ width: '100%' }}
                    />
                </Grid>,
            ],
        ],

        ...(false && {
            //I'm intentionally hiding it right now because it's broken
            mediaContent: [
                //23
                [
                    <FormLabel component="legend">
                        Please share any photo/video content you’d be willing
                        for us to share in our newsletters/social media!
                    </FormLabel>,
                ],
                [
                    <FileUploader
                        uppy={uppy}
                        thisEvent={theEvent}
                    ></FileUploader>,
                    <>
                        {theUploadedFiles.length > 0 && (
                            <Grid
                                container
                                // xs={12}
                                size={{ xs: 12 }}
                                sx={{ margin: '16px auto', width: '95%' }}
                                className="uploadedFiles"
                                justifyContent={'center'}
                            >
                                <Typography
                                    component="h2"
                                    sx={{ width: '100%', marginBottom: '10px' }}
                                >
                                    <AttachFileIcon
                                        sx={{
                                            fontSize: '1.4em',
                                            marginRight: '5px',
                                        }}
                                    />
                                    {theUploadedFiles.length > 1
                                        ? 'These files are'
                                        : 'This file is'}{' '}
                                    attached to this event:
                                </Typography>
                                <Masonry
                                    columns={{ xs: 3, sm: 4, md: 7, lg: 7 }}
                                    spacing={2}
                                >
                                    {theUploadedFiles.map((image, idx) => {
                                        const theFileLink =
                                            image.filetype &&
                                            image.filetype.split('/')[0] ===
                                                'image'
                                                ? 'https://lh3.googleusercontent.com/d/' +
                                                  image.driveID
                                                : 'https://drive.google.com/file/d/' +
                                                  image.driveID;
                                        if (image.driveID) {
                                            return (
                                                // <img
                                                //     src={
                                                //         'https://drive.google.com/file/d/' +
                                                //         image.driveID +
                                                //         '/uc?export=view'
                                                //     }
                                                //     alt="Image Description"
                                                // ></img>
                                                <Grid
                                                    item
                                                    key={idx}
                                                    sx={{
                                                        width: '100px',
                                                        margin: '10px',
                                                        overflowWrap:
                                                            'break-word',
                                                        textAlign: 'center',
                                                        fontSize: '.75em',
                                                    }}
                                                >
                                                    <a
                                                        // href={image.url}
                                                        href={theFileLink}
                                                        target="_blank"
                                                    >
                                                        <img
                                                            src={
                                                                'https://lh3.googleusercontent.com/d/' +
                                                                image.driveID
                                                            }
                                                            style={{
                                                                width: '100px',
                                                                padding: '3px',
                                                                border: '1px solid var(--primary-color)',
                                                            }}
                                                        />

                                                        <p>{image.name}</p>
                                                    </a>
                                                </Grid>
                                            );
                                        } else {
                                            return (
                                                <>
                                                    <Grid
                                                        item
                                                        key={idx}
                                                        sx={{
                                                            width: '100px',
                                                            margin: '10px',
                                                            overflowWrap:
                                                                'break-word',
                                                            textAlign: 'center',
                                                            fontSize: '.75em',
                                                        }}
                                                    >
                                                        <SpinnerCircular
                                                            size={60}
                                                            thickness={130}
                                                            speed={75}
                                                            color="rgba(255, 255, 217, 1)"
                                                            secondaryColor="rgba(16, 15, 14, 1)"
                                                        />

                                                        <p>{image.name}</p>
                                                    </Grid>
                                                </>
                                            );
                                        }
                                    })}
                                </Masonry>
                            </Grid>
                        )}
                    </>,
                ],
            ],
        }),
        endSlide: [
            [
                <Grid
                    item
                    sx={{
                        width: '250px',
                        margin: '-40px auto -20px',
                        textAlign: 'center',
                    }}
                >
                    <img
                        src={porchlightLogo}
                        alt=""
                        className="porchlightLogo"
                    />
                </Grid>,
                <Typography
                    component="h2"
                    sx={{ fontSize: '2.2em!important', textAlign: 'center' }}
                >
                    Thank you!
                </Typography>,
                // <Typography
                //     component="h2"
                //     sx={{ fontSize: '2.2em!important', textAlign: 'center' }}
                // >
                //     It helps more than you know...
                // </Typography>,
                <>
                    <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                            textWrap: 'balance',
                        }}
                    >
                        Porchlight is constantly growing and learning from each
                        other, and your insight is essential as we cultivate
                        this network of hosts, artists, and attendees.
                    </Typography>

                    {/* <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                        }}
                    >
                        Your collaboration and perspective is an essential part
                        of this process.
                    </Typography>
                    <Typography
                        component="p"
                        sx={{
                            textAlign: 'center',
                            marginTop: '16px',
                        }}
                    >
                        Thank you.
                    </Typography> */}

                    <Grid
                        item
                        container
                        justifyContent="center"
                        sx={{ marginTop: '16px' }}
                    >
                        <Button
                            btnwidth="300"
                            onClick={() => {
                                setDialogOpen(false);
                                if (
                                    typeof onNotificationDialogClose ===
                                    'function'
                                ) {
                                    onNotificationDialogClose();
                                }
                            }}
                        >
                            Close This Window
                        </Button>
                    </Grid>
                </>,
            ],
        ],
    };

    let query = useQuery();
    const queryEditField = query.get('field');
    const queryEventID = query.get('eventID');
    const queryOpen = query.get('open');
    const location = useLocation();
    let formStartIndex = 0;

    if (queryEditField) {
        const formGroupKeys = Object.keys(formGroups);
        formStartIndex =
            formGroupKeys.indexOf(queryEditField) > -1
                ? formGroupKeys.indexOf(queryEditField)
                : 0;
    }

    //// CARD INDEX ///////
    // const [formCardIndex, setIndex] = useState(formStartIndex);
    const [formCardIndex, setIndex] = useState(0);

    const cardIndex = formCardIndex;

    const [formCardDirection, setDirection] = useState(1);
    const transitions = useTransition(formCardIndex, {
        key: formCardIndex,
        initial: null,
        from: {
            opacity: 0,
            transform: `translateX(${formCardDirection * 60}vw)`,
        },
        enter: { opacity: 1, transform: 'translateX(0%)' },
        leave: {
            opacity: 0,
            transform: `translateX(${formCardDirection * -60}vw)`,
        },
        // config: config.molasses,
        config: { mass: 2, tension: 280, friction: 60 },
        // onRest: (_a, _b, item) => {
        //   if (formCardIndex === item) {
        //     set(cardIndex => (cardIndex + 1) % formGroups.length)
        //   }
        // },
        exitBeforeEnter: false,
    });
    const nextCard = (e) => {
        setDirection(1);
        if (changesMade.current) {
            onSubmit(e);
        }
        setIndex((cardIndex) => {
            //(cardIndex + 1) % Object.keys(formGroups).length;
            if (cardIndex === Object.keys(formGroups).length - 1) {
                //if it's at the end there's nothing next, don't loop around
                return cardIndex;
            } else {
                return cardIndex + 1;
            }
        });
    };
    const previousCard = (e) => {
        setDirection(-1);
        if (changesMade.current) {
            onSubmit(e);
        }
        setIndex((cardIndex) => {
            // if (cardIndex == 0) { //loop around to the last index
            //     cardIndex = Object.keys(formGroups).length;
            // }
            if (cardIndex == 0) {
                //if it's at the benninging there's nothing previous, don't loop around
                return cardIndex;
            } else {
                return cardIndex - 1;
            }
        });
    };

    //Dialog Functions
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleReviewDialogClose = () => {
        setDialogOpen(false);
        if (typeof onNotificationDialogClose === 'function') {
            onNotificationDialogClose();
        }
    };

    useEffect(() => {
        if (queryOpen !== 'survey') return;
        if (!queryEventID || String(theEvent._id) !== String(queryEventID)) {
            return;
        }
        const timer = setTimeout(
            () => setDialogOpen(true),
            NOTIFICATION_DIALOG_DELAY_MS
        );
        return () => clearTimeout(timer);
    }, [queryOpen, queryEventID, theEvent._id, location.key]);

    return (
        <Fragment key={`Fragment` + theEvent._id + theArtist._id}>
            <Dialog
                open={dialogOpen}
                onClose={handleReviewDialogClose}
                scroll="body"
                fullWidth
                maxWidth="lg"
                className="porchlightBG"
                // style={{
                //     minHeight: '90vh',
                //     height: '90vh',
                // }}
                PaperProps={{
                    style: {
                        minHeight: '82vh',
                        height: '82vh',
                    },
                }}
            >
                <MobileStepper
                    variant="progress"
                    steps={Object.keys(formGroups).length || cardIndex.length}
                    position="static"
                    activeStep={cardIndex}
                    sx={{
                        // width: '100cqw',
                        position: 'absolute',
                        top: 0,
                        padding: '0px',
                        left: 0,
                        right: 0,
                        width: '100%',
                        // backgroundColor: 'var(--link-color)',
                        '& .MuiLinearProgress-root': {
                            // width: { xs: '100%', sm: '50%' },
                            width: '100%',
                        },
                    }}
                    backButton={undefined}
                    nextButton={undefined}
                    LinearProgressProps={{ color: 'primary' }}
                />
                <DialogContent
                    sx={
                        {
                            // margin: '8px',
                            // border: '1px solid var(--primary-color)',
                        }
                    }
                >
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            backgroundColor: 'rgba(0 0 0 /.6)',
                            padding: '0',
                        }}
                    >
                        <StackDateforDisplay
                            date={theEvent?.bookingWhen}
                        ></StackDateforDisplay>
                    </Box>
                    <form className="form" onSubmit={(e) => onSubmit(e)}>
                        <Grid
                            container
                            direction="row"
                            alignItems="start"
                            justifyContent="center"
                            height="65vh"
                            sx={{ padding: '20px!important' }}
                            key={`cardGrid` + theEvent._id + theArtist._id}
                        >
                            <Grid
                                container
                                item
                                sx={{ width: '100%' }}
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                className="cardNav"
                            >
                                <Grid item>
                                    {/* { cardIndex > 0 ? (  */}
                                    <Button
                                        variant="contained"
                                        component="span"
                                        onClick={(e) => previousCard(e)}
                                        sx={{
                                            opacity: cardIndex > 0 ? 1 : 0.2,
                                            transition:
                                                'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 500ms',
                                        }}
                                    >
                                        <ArrowBackIcon></ArrowBackIcon>Previous
                                    </Button>
                                    {/* ) : '' } */}
                                </Grid>
                                {/* <Grid item>
                            <label htmlFor="submit">
                                <input id="submit" type="submit" hidden />
                                <Button
                                    variant="contained"
                                    component="span"
                                    onClick={(e) => onSubmit(e)}
                                >
                                    Save <SaveTwoToneIcon></SaveTwoToneIcon>
                                </Button>
                            </label>
                        </Grid> */}
                                <Grid item>
                                    {/* { cardIndex < formGroups.length - 1 ? ( */}
                                    <Button
                                        variant="contained"
                                        component="span"
                                        onClick={(e) => nextCard(e)}
                                        sx={{
                                            opacity:
                                                cardIndex !==
                                                Object.keys(formGroups).length -
                                                    1
                                                    ? 1
                                                    : 0.2,
                                            transition:
                                                'opacity 450ms cubic-bezier(0.23, 1, 0.32, 1) 500ms',
                                        }}
                                    >
                                        Next
                                        <ArrowForwardIcon></ArrowForwardIcon>
                                    </Button>
                                    {/* ) : ''} */}
                                </Grid>
                            </Grid>
                        </Grid>
                        {transitions((style, i) => (
                            <animated.div
                                className={'animatedFormGroup'}
                                key={'animatedFormGroup' + i}
                                style={{
                                    ...style,
                                    minHeight: 'inherit',
                                }}
                            >
                                <div
                                    className="form-group"
                                    key={'form-group' + i}
                                    style={{ maxWidth: '100%' }}
                                >
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        alignItems="center"
                                        //spacing={2}
                                        sx={{
                                            width: '100%',
                                            margin: '0 auto',
                                        }}
                                        key={
                                            `bookingDetails` + theEvent._id + i
                                        }
                                        //className="bookingDetails"
                                    >
                                        {/* <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}> */}

                                        {/* {formGroups && formGroups.length > 0 ? formGroups[i].map((formGroup, ind) => (  */}
                                        <Grid
                                            item
                                            // xs={12}
                                            size={{ xs: 12 }}
                                            sx={
                                                // i > 0 && {
                                                //     '--form-num': `'${i}'`,
                                                // }
                                                i >= 0 && {
                                                    '--form-num': `'${i + 1}'`,
                                                }
                                            } // this is where the form number is set
                                            data-form-num={i}
                                            className="formInquiry"
                                        >
                                            {
                                                formGroups[
                                                    Object.keys(formGroups)[i]
                                                ][0]
                                            }
                                        </Grid>
                                        {
                                            formGroups[
                                                Object.keys(formGroups)[i]
                                            ][1]
                                        }
                                    </Grid>
                                </div>
                            </animated.div>
                        ))}
                    </form>
                </DialogContent>
            </Dialog>
            {(!theEvent.hostReviewOfEvent ||
                !theEvent.hostReviewOfEvent._id) && (
                <Box
                    className="createdAt"
                    sx={{
                        position: 'absolute',
                        top: '8px',
                        right: '8px',
                    }}
                >
                    {' '}
                    <Typography
                        component="p"
                        sx={{
                            fontSize: '.7em',
                            fontFamily: 'var(--secondary-font)',
                            color: 'var(--link-color)',
                        }}
                    >
                        <FlareTwoToneIcon
                            style={{ fontSize: '1.5em' }}
                        ></FlareTwoToneIcon>{' '}
                        Please consider reviewing your experience hosting{' '}
                        {theArtist?.stageName ||
                            theEvent?.confirmedArtist?.stageName}
                        .
                    </Typography>
                </Box>
            )}
            <Grid item style={{ margin: '20px auto 0', alignSelf: 'center' }}>
                <Button btnwidth="250" onClick={() => setDialogOpen(true)}>
                    {theEvent &&
                    theEvent.hostReviewOfEvent &&
                    theEvent.hostReviewOfEvent._id
                        ? 'Edit Your Review'
                        : 'Review Your Experience'}
                </Button>
            </Grid>
        </Fragment>
    );
};

HostReviewsEvent.propTypes = {
    hostMe: PropTypes.object.isRequired,
    theEvent: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    hostReviewsEvent: PropTypes.func.isRequired,
    onNotificationDialogClose: PropTypes.func,
    // thisHostEvent: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    // console.log('HostReviewsEvent mapStateToProps ownProps', ownProps);
    // const thisHostEvent = state.event.myHostEvents.find(
    //     (myHostEvent) => myHostEvent._id === ownProps.theEvent._id
    // );
    // console.log(
    //     'HostReviewsEvent mapStateToProps thisHostEvent',
    //     thisHostEvent
    // );
    return {
        auth: state.auth,
        hostMe: state.host.me,
        // thisHostEvent: thisHostEvent,
    };
};

export default connect(mapStateToProps, {
    hostReviewsEvent,
    // })(withRouter(HostReviewsEvent)); //withRouter allows us to pass history objects
})(HostReviewsEvent);
